// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"278":"7fbfb08a83a8f7f8","5416":"f74b2b5a857f94f3"}[chunkId] + ".js";
};